import {Line} from 'vue-chartjs'

export default {
  extends: Line,
  props: ['dataset', 'title', 'rgbStyle', 'border'],
  data() {
    return {}
  },
  computed: {},
  methods: {
    prepareData(collection) {
      let total = this.border === '#eace17' ? 'total_returns' : 'total'
      let ret = []
      Object.keys(collection).forEach(o => {
        Object.keys(collection[o]).sort().forEach(k => {
          ret.push('total_percentage' in collection[o][k] ? collection[o][k].total_percentage : collection[o][k][total])
        })
      })
      return ret
    },
    prepareLabels(collection) {
      let ret = []
      Object.keys(collection).forEach(o => {
        for (let k in collection[o]) {
          ret.push(k)
        }
      })
      return ret.sort()
    },
    getTooltipProper(item, type) {
      if (item && item) {
        switch (type) {
          case 'Verkaufstatistik':
            return [
              'Verkäufe (' + item.total + '):',
              ' - Versendungen am selben Tag: ' + item.day_1,
              ' - Versendungen am zweiten Tag: ' + item.day_2,
              ' - Versendungen am dritten Tag: ' + item.day_3,
              ' - Versendungen nach dem dritten Tag: ' + item.later,
              '',
              'Marktplatz-Statistik:',
              ` - Schuhe.de: ${item.channels.schuhede.total}`,
              ` - Zalando: ${item.channels.zalando.total}`,
              ` - eBay: ${item.channels.ebay.total}`,
              ` - Amazon: ${item.channels.amazon.total}`,
              ` - Mirapodo: ${item.channels.mirapodo.total}`,
              ` - Check24: ${item.channels.check24.total}`,
              ` - Spartoo: ${item.channels.spartoo.total}`,
              ` - Tamaris: ${item.channels.tamaris.total}`
                ` - Tamaris AT: ${item.channels.tamaris_at.total}`
                ` - Goertz: ${item.channels.goertz.total}`,
              ` - Marco Tozzi: ${item.channels.marco_tozzi.total}`,
              ` - Caprice: ${item.channels.caprice.total}`,
              ` - Limango.de: ${item.channels.limango_de.total}`,
              ` - Kaufland.de: ${item.channels.kaufland_de.total}`
            ]
          case 'Stornos':
            return [
              'Stornos:',
              ' - Summe:' + item.total,
              ' - Stornos am selben Tag: ' + item.day_1,
              ' - Stornos am zweiten Tag: ' + item.day_2,
              ' - Stornos am dritten Tag: ' + item.day_3,
              ' - Stornos am vierten Tag: ' + item.day_4,
              ' - Stornos nach dem vierten Tag: ' + item.later,
              '',
              'Marktplatz-Statistik:',
              ` - Schuhe.de: ${item.channels.schuhede.total}`,
              ` - Zalando: ${item.channels.zalando.total}`,
              ` - eBay: ${item.channels.ebay.total}`,
              ` - Amazon: ${item.channels.amazon.total}`,
              ` - Mirapodo: ${item.channels.mirapodo.total}`,
              ` - Check24: ${item.channels.check24.total}`,
              ` - Spartoo: ${item.channels.spartoo.total}`,
              ` - Tamaris: ${item.channels.tamaris.total}`
                ` - Tamaris AT: ${item.channels.tamaris_at.total}`
                ` - Goertz: ${item.channels.goertz.total}`,
              ` - Marco Tozzi: ${item.channels.marco_tozzi.total}`,
              ` - Caprice: ${item.channels.caprice.total}`,
              ` - Limango.de: ${item.channels.limango_de.total}`,
              ` - Kaufland.de: ${item.channels.kaufland_de.total}`
            ]
          default:
            return [
              'Retouren:',
              ' - Verkäufe: ' + item.total_shippings,
              ' - Retouren: ' + item.total_returns,
              ' - Retourenprozent: ' + this.$options.filters.percentage(item.total_percentage),
              '',
              `Schuhe.de: ${this.$options.filters.percentage(item.channels.schuhede.percentage)} (Verkäufe: ${item.channels.schuhede.shippings}, Retouren: ${item.channels.schuhede.returns})`,
              '',
              `Zalando: ${this.$options.filters.percentage(item.channels.zalando.percentage)} (Verkäufe: ${item.channels.zalando.shippings}, Retouren: ${item.channels.zalando.returns})`,
              '',
              `eBay: ${this.$options.filters.percentage(item.channels.ebay.percentage)} (Verkäufe: ${item.channels.ebay.shippings}, Retouren: ${item.channels.ebay.returns})`,
              '',
              `Amazon: ${this.$options.filters.percentage(item.channels.amazon.percentage)} (Verkäufe: ${item.channels.amazon.shippings}, Retouren: ${item.channels.amazon.returns})`,
              '',
              `Mirapodo: ${this.$options.filters.percentage(item.channels.mirapodo.percentage)} (Verkäufe: ${item.channels.mirapodo.shippings}, Retouren: ${item.channels.mirapodo.returns})`,
              '',
              `Check24: ${this.$options.filters.percentage(item.channels.check24.percentage)} (Verkäufe: ${item.channels.check24.shippings}, Retouren: ${item.channels.check24.returns})`,
              '',
              `Spartoo: ${this.$options.filters.percentage(item.channels.spartoo.percentage)} (Verkäufe: ${item.channels.spartoo.shippings}, Retouren: ${item.channels.spartoo.returns})`,
              '',
              `Tamaris: ${this.$options.filters.percentage(item.channels.tamaris.percentage)} (Verkäufe: ${item.channels.tamaris.shippings}, Retouren: ${item.channels.tamaris.returns})`,
              `Tamaris AT: ${this.$options.filters.percentage(item.channels.tamaris_at.percentage)} (Verkäufe: ${item.channels.tamaris_at.shippings}, Retouren: ${item.channels.tamaris_at.returns})`,
              `Goertz: ${this.$options.filters.percentage(item.channels.goertz.percentage)} (Verkäufe: ${item.channels.goertz.shippings}, Retouren: ${item.channels.goertz.returns})`,
              `Marco Tozzi: ${this.$options.filters.percentage(item.channels.marco_tozzi.percentage)} (Verkäufe: ${item.channels.marco_tozzi.shippings}, Retouren: ${item.channels.marco_tozzi.returns})`,
              `Caprice: ${this.$options.filters.percentage(item.channels.caprice.percentage)} (Verkäufe: ${item.channels.caprice.shippings}, Retouren: ${item.channels.caprice.returns})`,
              `Limango.de: ${this.$options.filters.percentage(item.channels.limango_de.percentage)} (Verkäufe: ${item.channels.limango_de.shippings}, Retouren: ${item.channels.limango_de.returns})`,
              `Kaufland.de: ${this.$options.filters.percentage(item.channels.kaufland_de.percentage)} (Verkäufe: ${item.channels.kaufland_de.shippings}, Retouren: ${item.channels.kaufland_de.returns})`
            ]
        }
      }
    },
    getTooltips() {
      let ret = {
        displayColors: false,
        callbacks: {
          label: (tooltipItem, data) => {
            let item = Object.keys(this.dataset)[0]
            return this.getTooltipProper(this.dataset[item][tooltipItem.xLabel], data.datasets[0].label)
          },
          title: (ttip, data) => {
            let item = Object.keys(this.dataset)[0]
            return ttip[0].xLabel + '-' + item
          }
        },
        mode: 'x',
        intersect: false
      }
      return ret
    }
  },
  mounted() {
    this.gradient = this.$refs.canvas
      .getContext('2d')
      .createLinearGradient(0, 0, 0, 450)
    this.gradient.addColorStop(0, 'rgba(' + this.rgbStyle + ', 0.5)')
    this.gradient.addColorStop(0.25, 'rgba(' + this.rgbStyle + ', 0.37)')
    this.gradient.addColorStop(0.5, 'rgba(' + this.rgbStyle + ', 0.25)')
    this.gradient.addColorStop(0.75, 'rgba(' + this.rgbStyle + ', 0.12)')
    this.gradient.addColorStop(1, 'rgba(' + this.rgbStyle + ', 0)')
  },
  watch: {
    dataset() {
      this.$data._chart && this.$data._chart.destroy()
      let month = Object.keys(this.dataset)[0].split('-')[0] - 1
      let year = Object.keys(this.dataset)[0].split('-')[1]
      this.renderChart({
        labels: this.prepareLabels(this.dataset),
        datasets: [
          {
            label: this.$options.filters.translate(this.title),
            borderColor: this.border,
            pointBackgroundColor: this.border,
            borderWidth: 1,
            pointBorderColor: this.border,
            backgroundColor: this.gradient,
            data: this.prepareData(this.dataset)
          }
        ]
      }, {
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            },
            scaleLabel: {
              display: true,
              labelString: 'Tag'
            }
          }],
          yAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              callback: (label, index, labels) => {
                return label
              },
              suggestedMin: 0
            },
            scaleLabel: {
              display: true,
              labelString: 'Anzahl'
            }
          }]
        },
        title: {
          display: true,
          fontSize: 32,
          text: this.$options.filters.translate(this.title, this.$store.getters.language) + ' - ' + this.$options.filters.translate(moment().month(month).format('MMMM'), this.$store.getters.language) + ' ' + year,
          fontStyle: 'bold',
          fontColor: '#FFFFFF',
          padding: 30
        },
        legend: {
          display: false
        },
        responsive: true,
        hover: {
          mode: 'x',
          intersect: false
        },
        maintainAspectRatio: false,
        tooltips: this.getTooltips()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/Charts/LineChart.js